module.exports = __webpack_public_path__ + "static/media/feedbackbg.cab05ce1.jpg";